/**
 * components/Header.jsx
 * Page title, subtitle and "Add New" CTA — matches rules app Header.jsx pattern.
 */

import { Plus } from "lucide-react";
import { getAddNewUrl } from "../context/CrudContext";

export default function Header() {
    return (
        <div className="px-4 sm:px-6 py-5 border-b border-gray-200">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                <div>
                    <h1 className="text-xl sm:text-2xl font-bold text-gray-900 p-0 m-0">
                        Settings Rules
                    </h1>
                    <p className="mt-1 text-xs sm:text-sm text-gray-500">
                        Manage your zoom settings rules and configurations.
                    </p>
                </div>

                <a
                    href={getAddNewUrl()}
                    className="inline-flex items-center justify-center px-4 py-2 bg-accent text-white border border-accent shadow-btn-accent hover:bg-accent-hover hover:border-accent-hover text-sm font-medium rounded-md transition-all w-full sm:w-auto no-underline"
                >
                    <Plus className="w-4 h-4 me-2" />
                    Add New
                </a>
            </div>
        </div>
    );
}
